import { useContextAccessToken } from '../../permission/contexts/AnonShareTokenContext.js';
import { useWoody } from '../../woody/woody.js';
import { useAuthStatus } from '@fabric-app/compat';
import { Kind } from '@fabric/woody-client';
import { useQuery, useQueryClient } from '@tanstack/react-query';

const firstKey = "direct-subfolder-count-per-resource-id";
const useQueryDirectSubfolderCountPerResourceId = ({ folderIds }) => {
  const { client } = useWoody();
  const accessToken = useContextAccessToken();
  const authStatus = useAuthStatus();
  const query = useQuery({
    queryKey: [
      firstKey,
      folderIds
    ],
    queryFn: () => client.v2("/v2/folders/counts", {
      method: "post",
      body: {
        folderIds,
        kinds: [
          Kind.FOLDER
        ]
      }
    }),
    enabled: !!folderIds.length && !accessToken && authStatus === "authenticated"
  });
  return query;
};
const useQueryDirectSubfolderCountPerResourceIdInvalidate = () => {
  const queryClient = useQueryClient();
  return (folderIdsToUpdate) => {
    setTimeout(() => {
      queryClient.invalidateQueries({
        predicate: (query) => {
          const shouldInvalidate = query.queryKey[0] === firstKey && Array.isArray(query.queryKey[1]) && query.queryKey[1].some((resourceId) => folderIdsToUpdate.includes(resourceId));
          return shouldInvalidate;
        }
      });
    }, 200);
  };
};

export { useQueryDirectSubfolderCountPerResourceId, useQueryDirectSubfolderCountPerResourceIdInvalidate };
//# sourceMappingURL=useQueryDirectChildCountPerResourceId.js.map
